export const QUESTOES = {
  page: 'questoes-page',
  counterBadge: 'questoes-counter-badge',
  option: 'questoes-option',
  submitButton: 'questoes-submit-button',
  nextButton: 'questoes-next-button',
  feedback: 'questoes-feedback',
  filterDisciplina: 'questoes-filter-disciplina',
};

export const SIMULADOS = {
  page: 'simulados-page',
  card: 'simulados-card',
  startButton: 'simulados-start-button',
};

export const NAV = {
  home: 'nav-home',
  questoes: 'nav-questoes',
  simulados: 'nav-simulados',
  desempenho: 'nav-desempenho',
  logout: 'nav-logout',
};
